import { useMemo } from 'react';

import { useFilterQueryParams } from 'common/hooks/filters-params';
import type { FiltersParams, SortParams } from 'common/types/SortAndFilter';
import { useFilterList } from './use-filter-list';

interface UseHandleFiltersProps extends FiltersParams, Pick<SortParams, 'order'> {
  excludeCategory?: boolean;
  showCategoriesAsFilter?: boolean;
  initiallyExpanded?: string[];
}

export const useHandleFilters = ({
  order,
  filters,
  showCategoriesAsFilter,
  excludeCategory,
  initiallyExpanded = [],
}: UseHandleFiltersProps) => {
  const { url, onFilterChange, haveFiltersChanged } = useFilterQueryParams({
    filters,
    order,
  });

  const filteredList = useFilterList({
    filters,
    showCategoriesAsFilter,
    excludeCategory,
  });

  const defaultExpandedSections = useMemo(() => {
    if (showCategoriesAsFilter) {
      return ['category', ...initiallyExpanded];
    }

    return initiallyExpanded;
  }, [showCategoriesAsFilter, initiallyExpanded]);

  return {
    url,
    filters: filteredList,
    haveFiltersChanged,
    defaultExpandedSections,
    onFilterChange,
  };
};
